import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'
import styles from 'src/styles/common.module.scss'

const BREAKPOINT_RULES: Record<string, string[]> = {
    desktop: ['boletos'],
    small: ['boletos', 'consigue'],
}

export const TextHeaderEs = () => {
    const isDesktop = useMediaQuery('(min-width: 768px)')

    let breakAfterWords = BREAKPOINT_RULES.small

    if (isDesktop) {
        breakAfterWords = BREAKPOINT_RULES.desktop
    }

    return (
        <HighlightedText
            text="Elige tus boletos y consigue un bono"
            highlights={[
                { word: 'y' },
                { word: 'consigue' },
                { word: 'un' },
                { word: 'bono' },
            ]}
            breakAfterWords={breakAfterWords}
            className={styles.text_header}
        />
    )
}
